import { useMemo } from "react"
import { ALL_SPECIES } from "@/features/farm"
import useGetCurrentSpecies from "@/features/farm/hooks/use-get-current-species.ts"
import { useGetAnimalsCountString } from "@/features/home/hooks/use-get-animals-count-string.ts"

/**
 * This hook is used to retrieve the current species that the user has access to based on the permissions
 * @return Array of {label : string, value: string, count: number}
 */
export const useGetSpeciesOptions = () => {
  const speciesArray = useGetCurrentSpecies()
  const { animalCountMap } = useGetAnimalsCountString()

  const species_breeds = useMemo(() => {
    return speciesArray.filter(Boolean).map((species) => ({
      label: species.name,
      value: species.id,
      count: animalCountMap[species.name],
    }))
  }, [animalCountMap, speciesArray])

  return useMemo(
    () => [ALL_SPECIES, ...(species_breeds ?? [])],
    [species_breeds],
  )
}
